import React from 'react';

import { IIconProps, TIconType } from '../interface';

const CMModuleWhiteIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
			{...props?.innerSvgProps}
		>
			<g
				clipPath='url(#clip0_26445_725562)'
			>
				<path
					d='M20.0344 7.71564L14.7844 2.46564C14.6415 2.32635 14.4495 2.24889 14.25 2.25001H5.25C4.85218 2.25001 4.47064 2.40805 4.18934 2.68935C3.90804 2.97066 3.75 3.35219 3.75 3.75001V20.25C3.75 20.6478 3.90804 21.0294 4.18934 21.3107C4.47064 21.592 4.85218 21.75 5.25 21.75H18.75C19.1478 21.75 19.5294 21.592 19.8107 21.3107C20.092 21.0294 20.25 20.6478 20.25 20.25V8.25001C20.2511 8.05047 20.1737 7.85851 20.0344 7.71564ZM14.25 8.25001V4.12501L18.375 8.25001H14.25Z'
					fill='white'
				/>
				<path
					clipRule='evenodd'
					d='M8.84219 13.8887C9.05794 13.8887 9.2386 14.0522 9.26007 14.2668C9.29341 14.6002 9.68456 14.7623 9.94388 14.5501C10.1109 14.4135 10.3542 14.4256 10.5068 14.5782L10.755 14.8264C10.9075 14.9789 10.9197 15.2223 10.783 15.3893C10.5709 15.6486 10.7329 16.0397 11.0663 16.0731C11.281 16.0945 11.4445 16.2752 11.4445 16.491V16.842C11.4445 17.0577 11.281 17.2384 11.0663 17.2598C10.733 17.2932 10.5709 17.6843 10.7831 17.9436C10.9197 18.1105 10.9076 18.3538 10.755 18.5064L10.5068 18.7546C10.3542 18.9072 10.1109 18.9193 9.94389 18.7827C9.68458 18.5705 9.29341 18.7326 9.26007 19.066C9.2386 19.2807 9.05793 19.4442 8.84215 19.4442H8.49121C8.27545 19.4442 8.09479 19.2807 8.07332 19.066C8.03998 18.7327 7.64881 18.5706 7.38949 18.7828C7.2225 18.9194 6.97915 18.9073 6.82658 18.7547L6.57841 18.5065C6.42584 18.354 6.41371 18.1106 6.55033 17.9436C6.7625 17.6843 6.60048 17.2932 6.26709 17.2598C6.05241 17.2384 5.88892 17.0577 5.88892 16.8419V16.491C5.88892 16.2752 6.05242 16.0945 6.26713 16.0731C6.60055 16.0397 6.76257 15.6485 6.55038 15.3892C6.41374 15.2222 6.42587 14.9788 6.57845 14.8262L6.8266 14.5781C6.97916 14.4255 7.22254 14.4134 7.38953 14.55C7.64882 14.7621 8.03999 14.6002 8.07332 14.2668C8.09479 14.0521 8.27543 13.8887 8.49116 13.8887H8.84219ZM8.66669 17.7776C9.28034 17.7776 9.7778 17.2801 9.7778 16.6664C9.7778 16.0528 9.28034 15.5553 8.66669 15.5553C8.05304 15.5553 7.55558 16.0528 7.55558 16.6664C7.55558 17.2801 8.05304 17.7776 8.66669 17.7776Z'
					fill='#2E2E6B'
					fillRule='evenodd'
				/>
				<path
					d='M8.66678 17.7779C9.28042 17.7779 9.77789 17.2804 9.77789 16.6668C9.77789 16.0531 9.28042 15.5557 8.66678 15.5557C8.05313 15.5557 7.55566 16.0531 7.55566 16.6668C7.55566 17.2804 8.05313 17.7779 8.66678 17.7779Z'
					stroke='#2E2E6B'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
			</g>
			<defs>
				<clipPath
					id='clip0_26445_725562'
				>
					<rect
						fill='white'
						height='24'
						width='24'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default CMModuleWhiteIcon;
